module.exports = __webpack_public_path__ + "img/pic_home_case_2.1e9d5f40.png";